module.exports = __webpack_public_path__ + "static/ncsa_logo_new-e8c1b9be6aa9504bd9d8772e3b14de8c.png";